import { Link, useNavigate } from "react-router-dom";
import { PhoneCall, ShieldCheck, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

export default function Register() {
  const nav = useNavigate();

  // If someone lands here (bookmark, old link), redirect to login after a
  // short beat so they can read the message.
  useEffect(() => {
    const t = setTimeout(() => nav("/login", { replace: true }), 6000);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div
      className="min-h-screen grid md:grid-cols-2 bg-white"
      data-testid="register-closed"
    >
      <div className="flex items-center justify-center p-6 order-2 md:order-1">
        <div className="w-full max-w-sm space-y-6 text-center">
          <div className="w-14 h-14 rounded-full bg-[#0055FF]/10 grid place-items-center mx-auto">
            <Lock className="w-6 h-6 text-[#0055FF]" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold">
              Registration is closed
            </h1>
            <p className="text-sm text-slate-500 mt-2 leading-relaxed">
              This workspace is private. New accounts can only be created by
              the workspace owner from inside the dashboard.
            </p>
          </div>

          <div className="border border-slate-200 rounded-md p-4 text-left bg-slate-50">
            <div className="mono text-[10px] uppercase tracking-widest text-slate-500 mb-2 flex items-center gap-1">
              <ShieldCheck className="w-3.5 h-3.5" /> How to get access
            </div>
            <ol className="text-sm text-slate-700 space-y-1 list-decimal list-inside">
              <li>Ask the owner to add you from Employees.</li>
              <li>They&apos;ll share your email + a starter password.</li>
              <li>Sign in below and change your password later.</li>
            </ol>
          </div>

          <Link to="/login" data-testid="register-goto-login">
            <Button className="w-full bg-[#0055FF] hover:bg-[#0040CC] h-11">
              Go to sign in
            </Button>
          </Link>
          <div className="mono text-[10px] text-slate-400">
            You&apos;ll be redirected in a few seconds…
          </div>
        </div>
      </div>

      <div className="hidden md:block relative bg-[#050914] overflow-hidden order-1 md:order-2">
        <div className="absolute inset-0 grid-paper-dark opacity-70" />
        <div
          className="absolute -bottom-16 -left-16 w-[420px] h-[420px] rounded-full"
          style={{
            background:
              "radial-gradient(closest-side, rgba(255,80,0,0.25), transparent 70%)",
          }}
        />
        <div className="relative p-10 h-full flex flex-col text-white">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="Computer Care"
              className="w-9 h-9 rounded-md bg-white p-0.5 object-contain"
            />
            <span className="font-heading font-bold text-lg">Computer Care</span>
          </Link>
          <div className="mt-auto max-w-md">
            <div className="mono text-xs uppercase tracking-widest text-[#FF5000]">
              Invite-only workspace
            </div>
            <h2 className="font-heading text-3xl mt-3 leading-tight">
              Your customer conversations stay yours.
            </h2>
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              Only people the owner adds can sign in. No public signup, no
              random accounts, no leaked recordings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
